
(() => {
  let scale = 1;
  let x = 0;
  let y = 0;
  let startX = 0;
  let startY = 0;
  let startDistance = 0;
  let startScale = 1;
  let image = null;

  const distance = (a, b) =>
    Math.hypot(a.clientX - b.clientX,
               a.clientY - b.clientY);

  function update() {
    if (image) {
      image.style.transform =
        `translate(${x}px, ${y}px) scale(${scale})`;
    }
  }

  function reset() {
    if (image) image.style.transform = '';
    image = null;
    scale = 1;
    x = 0;
    y = 0;
  }

  document.addEventListener('touchstart', (e) => {
    if (!matchMedia('(max-width: 749px)').matches) return;

    const img = e.target.closest(
      'product-modal[open] img.active'
    );
    if (!img) return;

    if (image !== img) {
      reset();
      image = img;
    }

    if (e.touches.length === 2) {
      startDistance = distance(e.touches[0], e.touches[1]);
      startScale = scale;
      startX = x;
      startY = y;
    } else if (e.touches.length === 1) {
      startX = e.touches[0].clientX - x;
      startY = e.touches[0].clientY - y;
    }
  }, { passive: true });

  document.addEventListener('touchmove', (e) => {
    if (!image || !image.closest('product-modal[open]'))
      return;

    if (e.touches.length === 2 && startDistance) {
      e.preventDefault();
      scale = Math.min(4, Math.max(1,
        startScale * distance(e.touches[0], e.touches[1])
        / startDistance
      ));
      update();
    } else if (e.touches.length === 1 && scale > 1) {
      e.preventDefault();
      x = e.touches[0].clientX - startX;
      y = e.touches[0].clientY - startY;
      update();
    }
  }, { passive: false });

  document.addEventListener('touchend', (e) => {
    if (!image) return;
    startDistance = 0;

    if (e.touches.length === 1) {
      startX = e.touches[0].clientX - x;
      startY = e.touches[0].clientY - y;
    }
  });

  document.querySelectorAll('product-modal').forEach(modal => {
    new MutationObserver(() => {
      if (!modal.hasAttribute('open')) reset();
    }).observe(modal, { attributes: true, attributeFilter: ['open'] });
  });
})();
